import { useParams } from "react-router-dom";
import { OosConfirmationContent } from "../components/OosConfirmationContent";
import { useNextPendingTask, useFetchJob } from "@labeling-tools/api/lebron/react-query-hooks";
import { LoadingOverlay } from "@mantine/core";
import { RESULTS_SIDEBAR_WIDTH } from "@/config/data";
import { ConfirmationResultsSidebar } from "@/components/ConfirmationResultsSidebar";
import { isEmpty } from "lodash";

export const OosConfirmationQa = () => {
  const { jobId } = useParams();

  const { data: job } = useFetchJob(jobId || "");
  const { data: nextPendingTask, isLoading: nextPendingTaskLoading } =
    useNextPendingTask(jobId || "");
  const task = nextPendingTask
    ? { ...nextPendingTask, result: nextPendingTask?.data?.confirmation_result }
    : null;

  if (nextPendingTaskLoading) {
    return <LoadingOverlay />;
  }
  const hasResults = !!task?.result && !isEmpty(task.result);
  return (
    <div>
      {/* main content */}
      <div style={{ paddingRight: hasResults ? RESULTS_SIDEBAR_WIDTH : 0 }}>
        <OosConfirmationContent mode="confirmation-qa" />
      </div>

      {/* results sidebar */}
      {hasResults && (
        <ConfirmationResultsSidebar mode="confirmation-qa" task={task} testing={job?.testing} />
      )}
    </div>
  );
};
